import { render } from "./ReclamationEntry.vue?vue&type=template&id=554d21ec"
import script from "./ReclamationEntry.vue?vue&type=script&lang=js"
export * from "./ReclamationEntry.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mohammadali/code/pnp-companies-website-typo3/extensions/pnpform/Resources/Private/Vue/form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__